import { incidents, posts } from "assets/data/posts";
import { FeedIncident, ThreadPost } from "components";
import { useParams } from "react-router-dom";
import Breadcrumb, { BreadcrumbObject } from "ui/files/core/Breadcrumb";
import ArrowBackIosNewRoundedIcon from "@mui/icons-material/ArrowBackIosNewRounded";
import { Link } from "react-router-dom";

const Incidents = () => {
    const params = useParams();

    console.log("params: ", params.id);

    const breadcrumb: BreadcrumbObject[] = [
        {
            path: "/",
            text: "Main"
        },
        {
            path: "/incidents",
            text: "incidents"
        }
    ];

    return (
        <section className="w-full h-full flex flex-col relative">
            <div className="w-full h-full flex relative  overflow-auto">
                <div className="w-full flex flex-col px-10 py-2">
                    <div className="flex justify-between items-center w-full text-center">
                        <Link to="/incidents">
                            <ArrowBackIosNewRoundedIcon
                                fontSize="small"
                                className="dark:text-white"
                            />
                        </Link>
                        <Breadcrumb
                            breadcrumb={breadcrumb}
                            currentPath="View Incident"
                        />
                    </div>
                    <div className="w-full items-center flex flex-col gap-10 px-10 ">
                        <div className="card thread-post">
                            <FeedIncident
                                incident={incidents[0]}
                                showLink={false}
                            />
                        </div>
                        <ThreadPost
                            post={posts[0]}
                            threads={posts}
                            showThreads
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Incidents;
